import { render, staticRenderFns } from "./abnormalLog.vue?vue&type=template&id=2272571a&scoped=true&"
import script from "./abnormalLog.vue?vue&type=script&lang=js&"
export * from "./abnormalLog.vue?vue&type=script&lang=js&"
import style0 from "./abnormalLog.vue?vue&type=style&index=0&id=2272571a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272571a",
  null
  
)

export default component.exports